import { useState } from 'preact/hooks';
import { Field, fieldId } from './Field';

export interface SelectOption<T extends string | number> {
  value: T;
  label: string;
}

export function Select<T extends string | number>({ label, hint, value, options, onChange }: { label: string; hint?: string; value: T; options: SelectOption<T>[]; onChange: (v: T) => void }) {
  const [id] = useState(() => fieldId('select'));
  return (
    <Field label={label} hint={hint} htmlFor={id}>
      <div class="select">
        <select
          id={id}
          value={String(value)}
          onChange={(e) => {
            const raw = (e.currentTarget as HTMLSelectElement).value;
            const opt = options.find((o) => String(o.value) === raw);
            if (opt) onChange(opt.value);
          }}
        >
          {options.map((o) => (
            <option key={String(o.value)} value={String(o.value)}>
              {o.label}
            </option>
          ))}
        </select>
      </div>
    </Field>
  );
}
